//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ROLES_LIST, PERIODS, PATTERNS_VALIDATION, DATAPLEX_STATES } from '@/js/constants';
export default {
  props: {
    value: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    view: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    var _this = this;
    return {
      model: this.value,
      key_table: 1,
      pagination_permissions: {
        total: 0,
        limit: 10,
        offset: 1,
        current: 1
      },
      headers_permissions: [{
        value: 'email',
        text: 'Usuario'
      }, {
        value: 'administrator',
        text: 'Administrador'
      },
      //{ value: 'view_permission', text: 'Ver' },
      {
        value: 'actions',
        text: 'Acciones'
      }],
      rules: {
        email: [function (v) {
          return !!v || _this.traductor('common.field_required');
        }, function (v) {
          return PATTERNS_VALIDATION.EMAIL_GENERAL.test(v) || 'Ingrese un correo electrónico válido.';
        }]
      }
    };
  },
  methods: {
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    addRowPermission: function addRowPermission() {
      this.model.unshift({
        new: true,
        timestamp: new Date().getTime()
      });
    },
    deletePermissions: function deletePermissions(permission) {
      if (permission.created_user) {
        permission.deleted = true;
        this.key_table += 1;
      } else {
        var find = this.model.find(function (x) {
          return x.timestamp == permission.timestamp;
        });
        if (find) {
          var index = this.model.indexOf(find);
          console.log(this.model, permission.timestamp);
          if (index != -1) {
            this.model.splice(index, 1);
          }
        }
        this.key_table += 1;
      }
    },
    validateForm: function validateForm() {
      if (this.$refs.form_permission.validate()) return true;
      return false;
    }
  },
  watch: {
    model: function model(newValue) {
      //console.log("aqui-------------------",newValue)
      this.$emit('input', newValue.value ? newValue.value : newValue);
      this.$emit('change');
    },
    value: function value(newValue) {
      this.model = newValue.value ? newValue.value : newValue;
    }
  },
  computed: {
    filteredItems: function filteredItems() {
      return this.model.filter(function (x) {
        return !x.deleted;
      });
    }
  }
};